import Logo from 'common/Components/Logo';
import Layout from 'common/Layouts';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import FormTwoFactor from './components/form';

type IDesktopOtpModuleType = {
  handleSubmitOtp: (data: ISubmitOtpModuleType) => void;
};

const DesktopOtpModule: FC<IDesktopOtpModuleType> = ({ handleSubmitOtp }) => {
  const { t } = useTranslation();

  const getTitle = () => {
    const pageName = t(`FormSide.ValidationCodeText`);
    const brokerName = t(`BrokerCode_${window.api?.BROKER_CODE}.Title`);
    const separateSymbol = ' - ';
    return pageName + separateSymbol + brokerName;
  };

  return (
    <Layout title={getTitle()}>
      <Logo />
      <FormTwoFactor {...{ handleSubmitOtp }} />
    </Layout>
  );
};

export default DesktopOtpModule;
